module.exports = __webpack_public_path__ + "media/images/countryrect/sc-b347eb8bb23f755a3e1c801cf33603a3.svg";